import { api } from './client.js';

const unwrap = (resp) => resp.data?.data;

// ── Absence & Accruals (/absence) ─────────────────────────────────────
export const absenceApi = {
  // absence plans
  listPlans: (params) => api.get('/absence/plans', { params }).then(unwrap),
  getPlan: (id) => api.get(`/absence/plans/${id}`).then(unwrap),
  createPlan: (payload) => api.post('/absence/plans', payload).then(unwrap),
  updatePlan: (id, patch) => api.patch(`/absence/plans/${id}`, patch).then(unwrap),
  deletePlan: (id) => api.delete(`/absence/plans/${id}`).then(unwrap),

  // accrual policies
  listPolicies: (params) => api.get('/absence/policies', { params }).then(unwrap),
  getPolicy: (id) => api.get(`/absence/policies/${id}`).then(unwrap),
  createPolicy: (payload) => api.post('/absence/policies', payload).then(unwrap),
  updatePolicy: (id, patch) => api.patch(`/absence/policies/${id}`, patch).then(unwrap),
  deletePolicy: (id) => api.delete(`/absence/policies/${id}`).then(unwrap),

  // accruals + ledger + balances + adjustments
  runAccruals: (params) => api.post('/absence/accruals/run', {}, { params }).then(unwrap),
  listLedger: (params) => api.get('/absence/ledger', { params }).then(unwrap),
  balances: (employeeId) => api.get('/absence/balances', { params: { employee_id: employeeId } }).then(unwrap),
  addAdjustment: (payload) => api.post('/absence/adjustments', payload).then(unwrap),

  // absence requests (self-service create/list/view/cancel; admin approve/reject)
  listRequests: (params) => api.get('/absence/requests', { params }).then(unwrap),
  getRequest: (id) => api.get(`/absence/requests/${id}`).then(unwrap),
  createRequest: (payload) => api.post('/absence/requests', payload).then(unwrap),
  approveRequest: (id, payload) => api.put(`/absence/requests/${id}/approve`, payload || {}).then(unwrap),
  rejectRequest: (id, payload) => api.put(`/absence/requests/${id}/reject`, payload || {}).then(unwrap),
  cancelRequest: (id) => api.put(`/absence/requests/${id}/cancel`).then(unwrap),
};
